import { Dropdown } from "neetoui";

import { MENU_ITEM_TYPES } from "./constants";
import Submenu from "./Submenu";

const { MenuItem, Divider } = Dropdown;

const MoreDropdownMenuItem = ({
  onClick,
  label,
  type = MENU_ITEM_TYPES.menuItem,
  hasSubItems = false,
  ...menuItemProps
}) => {
  if (type === MENU_ITEM_TYPES.divider) {
    return <Divider role="separator" />;
  }

  if (hasSubItems) {
    return <Submenu {...{ label, ...menuItemProps }} />;
  }

  return (
    <MenuItem.Button {...{ onClick, ...menuItemProps }} role="menuitem">
      {label}
    </MenuItem.Button>
  );
};

export default MoreDropdownMenuItem;
